export default __webpack_public_path__ + "static/media/StratCap-Securities-Logo.6c45e5cf.png";